class CustomModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal:
        this.props.showModal === undefined ? true : this.props.showModal
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal) {
      this.setState({ showModal: true });
    }
    if (!nextProps.showModal && this.state.showModal && this.props.showModal) {
      this.handleHide();
    }
  }

  handleHide() {
    if (this.props.handleHide) {
      this.props.handleHide();
    }
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap">
        <Modal
          show={this.state.showModal}
          container={this.props.container}
          onHide={this.handleHide}
          bsSize={
            this.props.small ? "small" : this.props.medium ? "medium" : "large"
          }
          backdrop="static"
          aria-labelledby="contained-modal-title-sm"
          dialogClassName={this.props.className}
        >
          <Modal.Header>
            <div
              className="title-container"
              style={{ display: "inline-block" }}
            >
              <h3>{this.props.MessageTitle || ""}</h3>
            </div>
            <button
              id="close-modal"
              type="button"
              className="close-button"
              onClick={() => {
                this.handleHide();
                this.props.LeftButtonAction && this.props.LeftButtonAction();
              }}
            >
              <i className="fa fa-times" />
            </button>
          </Modal.Header>
          <Modal.Body>
            {this.props.showTextSection ? (
              <div
                className={
                  "body-container " + (this.props.showLine ? "show-line" : "")
                }
              >
                {this.props.msg}
              </div>
            ) : (
              <div className="body-container">
                <div className="col-sm-3 col-xs-12 icon-container">
                  <i
                    className={`fa ${this.props.iconClass ||
                      i18next.t("iconoModalError")} ${this.props.iconColor ||
                      i18next.t("colorModalError")}`}
                    aria-hidden="true"
                  />
                </div>
                <div className="col-sm-9 col-xs-12 messages">
                  <p>{this.props.msg || i18next.t("msgModalError")}</p>
                </div>
              </div>
            )}
          </Modal.Body>
          {this.props.footer ? (
            <Modal.Footer className="footer-cancel-process">
              <div className="row">
                {this.props.hideLeftButton ? (
                  ""
                ) : (
                  <div className="btn-container margin-r">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => {
                        this.handleHide();
                        this.props.LeftButtonAction &&
                          this.props.LeftButtonAction();
                      }}
                    >
                      {this.props.LeftButtonText}
                    </button>
                  </div>
                )}
                {this.props.hideRightButton ? (
                  ""
                ) : (
                  <div className="btn-container margin-r">
                    <button
                      className={`btn ${
                        this.props.disabledButton
                          ? "btn-disabled"
                          : "btn-default"
                      }`}
                      disabled={this.props.disabled}
                      type="button"
                      onClick={() => {
                        this.handleHide();
                        this.props.RightButtonAction &&
                          this.props.RightButtonAction();
                      }}
                    >
                      {this.props.RightButtonText}
                    </button>
                  </div>
                )}
              </div>
            </Modal.Footer>
          ) : !this.props.iconClass ? (
            <Modal.Footer className="footer-cancel-process">
              <div className="row">
                <div className="btn-container margin-r">
                  <button
                    className={`btn ${
                      this.props.disabledButton ? "btn-disabled" : "btn-default"
                    }`}
                    disabled={this.props.disabled}
                    type="button"
                    onClick={() => {
                      this.handleHide();
                      this.props.RightButtonAction &&
                        this.props.RightButtonAction();
                    }}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </Modal.Footer>
          ) : (
            ""
          )}
        </Modal>
      </div>
    );
  }
}

const Modal = ReactBootstrap.Modal;

export default CustomModal;
